import { DateHelpers } from "../helpers/date-helpers";
import { ObjectHelpers } from "../helpers/object-helpers";
import { IChartDataService } from "../models/base/chart-data-service.interface";
import { ChartStyleColorModel } from "../models/chart-style/chart-style-color.model";
import { ChartStyleSettingsModel } from "../models/chart-style/chart-style-settings.model";
import { RealtimeTradeDataModel } from "../models/data-point/realtime-trade-data.model";
import { TIChartPointModel } from "../models/data-point/ti-chart-point.model";
import { TIIndicatorDataModel } from "../models/data-point/ti-indicator-data.model";
import { DrawEarningNotificationDataModel } from "../models/earning/draw-earning-notification-data.model";
import { ChartType } from "../models/enum/chart-type.enum";
import { Timeframe } from "../models/enum/timeframe.enum";
import { LimitAlertModel } from "../models/limit-alert/limit-alert.model";
import { TiChartPnpContainer } from "../ti-chart-pnp.container";
declare const window: any;
declare const winformObj: any;

const color = require('../library/darken-color.js');

export class WindowFormPnPChartDataService implements IChartDataService {
    
    private subscribeChartRequestingNewSymbolDataCallbacks: Array<Function> = [];
    private subscribeInitChartDataCallbacks: Array<Function> = [];
    private subscribeInitChartIndicatorsDataCallbacks: Array<Function> = [];
    private subscribeUpdate10sRefreshChartDataCallbacks: Array<Function> = [];
    private subscribeUpdateChartHistoryDataCallbacks: Array<Function> = [];
    private subscribeUpdateHistoryIndicatorsDataCallbacks: Array<Function> = [];
    private subscribeRealtimeDataCallbacks: Array<Function> = [];
    private subscribeChartStyleDataCallbacks: Array<Function> = [];
    private subscribePriceAlertsDataCallbacks: Array<Function> = [];
    private subscribeDrawEarningNotificationDataCallbacks: Array<Function> = [];

    private baseChart: TiChartPnpContainer;
    
    private lastPrice = 0;

    private symbol = '';

    constructor(baseChart: TiChartPnpContainer) {
        this.baseChart = baseChart;

        this.onSubscribeInitChartData();
        this.onSubscribeUpdate10sRefreshChartData();
        this.onSubscribeUpdateChartHistoryData();
        this.onSubscribeRealtimeData();
    }

    public getSymbolLabel(): string {
        return this.symbol;
    }
    
    private subscribedChartRequestingNewSymbolData = false;
    public subscribeChartRequestingNewSymbolData(callback: Function) {
        this.subscribeChartRequestingNewSymbolDataCallbacks.push(callback);

        if (!this.subscribedChartRequestingNewSymbolData) {
            this.subscribedChartRequestingNewSymbolData = true;
            this.baseChart.baseChart.chartService.subscribeChartRequestingNewSymbolData((symbol: string, timeframe: Timeframe) => {
                if (this.symbol != symbol) {
                    this.symbol = symbol;            
                }
                
                for (const callback of this.subscribeChartRequestingNewSymbolDataCallbacks) {
                    callback(symbol, timeframe);
                }
            });
        }
    }

    public subscribeInitChartData(callback: Function) {
        this.subscribeInitChartDataCallbacks.push(callback);
    }

    private onSubscribeInitChartData() {
        window.initPnPChartData = (data: Array<TIChartPointModel>, timeframe: Timeframe, symbol: string, chartType: ChartType) => {
            
            this.symbol = symbol;
            
            const model: Array<TIChartPointModel> = [];
            if (data && data.length) {
                for (let i = 0; i < data.length; i++) {
                    model.push(new TIChartPointModel(data[i]));
                }
            }
            console.log('subscribeInitPnPChartData: ', model, timeframe, symbol, chartType);
            
            if (model?.length) {
                const lastPoint = model[model.length - 1];
                this.lastPrice = lastPoint.close;
            }

            for (const callback of this.subscribeInitChartDataCallbacks) {
                callback(model, timeframe, symbol, chartType);
            }

            
            this.onSubscribeInitChartIndicatorsData();
            // this.onSubscribeLastPriceData();
        };
    }

    public subscribeInitChartIndicatorsData(callback: Function) {
        this.subscribeInitChartIndicatorsDataCallbacks.push(callback);
    }

    private onSubscribeInitChartIndicatorsData() {
        const tiIndicatorsData: Array<TIIndicatorDataModel> = [];
        for (const callback of this.subscribeInitChartIndicatorsDataCallbacks) {
            callback(tiIndicatorsData);
        }
    }

    public subscribeInitChartComparisonsData(callback: Function) {
    }

    public subscribeInitChartDrawingTools(callback: Function) {
    }

    public subscribeUpdate10sRefreshChartData(callback: Function) {
        this.subscribeUpdate10sRefreshChartDataCallbacks.push(callback);
    }

    private onSubscribeUpdate10sRefreshChartData() {
        window.update10sRefreshPnPChartData = (data: Array<TIChartPointModel>) => {
            const model: Array<TIChartPointModel> = [];
            if (data && data.length) {
                for (let i = 0; i < data.length; i++) {
                    model.push(new TIChartPointModel(data[i]));
                }
            }

            if (model?.length) {
                const lastPoint = model[model.length - 1];
                this.lastPrice = lastPoint.close;
            }

            // console.log('update10sRefreshPnPChartData: ', model);
            for (const callback of this.subscribeUpdate10sRefreshChartDataCallbacks) {
                callback(model);
            }

            // this.onSubscribeLastPriceData();
        };
    }

    public subscribeUpdate10sRefreshIndicatorsData(callback: Function) {
    }

    public subscribeUpdateChartHistoryData(callback: Function) {
        this.subscribeUpdateChartHistoryDataCallbacks.push(callback)
    }

    private onSubscribeUpdateChartHistoryData() {
        window.updatePnPChartHistoryData = (data: Array<TIChartPointModel>) => {
            const model: Array<TIChartPointModel> = [];
            if (data && data.length) {
                for (let i = 0; i < data.length; i++) {
                    model.push(new TIChartPointModel(data[i]));
                }
            }
            // console.log('updatePnPChartHistoryData: ', model);
            for (const callback of this.subscribeUpdateChartHistoryDataCallbacks) {
                callback(model);
            }

            this.onSubscribeUpdateHistoryIndicatorsData();
        };
    }

    public subscribeUpdateHistoryIndicatorsData(callback: Function) {
        this.subscribeUpdateHistoryIndicatorsDataCallbacks.push(callback);
    }

    private onSubscribeUpdateHistoryIndicatorsData() {
        for (const callback of this.subscribeUpdateHistoryIndicatorsDataCallbacks) {
            callback([]);
        }
    }

    public subscribeUpdateChartHistoryComparisonData(callback: Function) {
    }

    public subscribeRealtimeData(callback: Function) {
        this.subscribeRealtimeDataCallbacks.push(callback);
    }

    private onSubscribeRealtimeData() {
        window.updatePnPRealtimeData = (data: RealtimeTradeDataModel) => {
            const model = new RealtimeTradeDataModel(data);
            // console.log('subscribeRealtimeData :', model);
            for (const callback of this.subscribeRealtimeDataCallbacks) {
                callback(model);
            }
        };
    }

    private subscribedChartStyle = false;
    private chartStyle: ChartStyleSettingsModel | null = null; 
    public subscribeChartStyleData(callback: Function) {
        this.subscribeChartStyleDataCallbacks.push(callback);

        if (this.subscribedChartStyle) {
            return;
        }

        this.subscribedChartStyle = true;
        this.baseChart.baseChart.chartService.subscribeChartStyleData((style: ChartStyleSettingsModel) => {
            const model = new ChartStyleSettingsModel(ObjectHelpers.copy(style));
            
            model.chartType = ChartType.Area;
            model.isOneColor = true;
            model.selectedLineColor = new ChartStyleColorModel({ r: 0, g: 91, b: 129 });
            model.chartTypeLineWidth = 1;
            model.zoomLevel = -3;

            if (style.chartStylePIPSettings) {
                model.isGradientAreaColorChecked = style.chartStylePIPSettings.isGradientAreaColorChecked;
                model.isGradientChecked = style.chartStylePIPSettings.isGradientChecked;
                model.watermarkOpacity = style.chartStylePIPSettings.watermarkOpacity;

                const selectedChartBackgroundColorRGB = style.chartStylePIPSettings.selectedChartBackgroundColor;
                model.selectedChartBackgroundColor = new ChartStyleColorModel(selectedChartBackgroundColorRGB);
    
                const selectedChartGradientColorRGB = style.chartStylePIPSettings.selectedChartGradientColor;
                model.selectedChartGradientColor = new ChartStyleColorModel(selectedChartGradientColorRGB);

                const selectedPriceTextColorRGB = style.chartStylePIPSettings.selectedPriceTextColor;
                model.selectedPriceTextColor = new ChartStyleColorModel(selectedPriceTextColorRGB);
    
                const selectedChartDateTextColorRGB = style.chartStylePIPSettings.selectedDateTextColor;
                model.selectedDateTextColor = new ChartStyleColorModel(selectedChartDateTextColorRGB);

                const selectedUpCandleColorRGB = style.chartStylePIPSettings.selectedUpCandleColor;
                model.selectedUpCandleColor = new ChartStyleColorModel(selectedUpCandleColorRGB);

                const selectedDownCandleColorRGB = style.chartStylePIPSettings.selectedDownCandleColor;
                model.selectedUpCandleColor = new ChartStyleColorModel(selectedDownCandleColorRGB);

                const selectedOutlineWickColorRGB = style.chartStylePIPSettings.selectedOutlineWickColor;
                model.selectedUpCandleColor = new ChartStyleColorModel(selectedOutlineWickColorRGB);

                const selectedStatusLineTextColorRGB = style.chartStylePIPSettings.selectedStatusLineTextColor;
                model.selectedUpCandleColor = new ChartStyleColorModel(selectedStatusLineTextColorRGB);

                const selectedLineColorRGB = style.chartStylePIPSettings.selectedLineColor;
                model.selectedLineColor = new ChartStyleColorModel(selectedLineColorRGB);

                const watermarkColorRGB = style.chartStylePIPSettings.watermarkColor;
                model.watermarkColor = new ChartStyleColorModel(watermarkColorRGB);
            } else {
                model.isGradientAreaColorChecked = true;
                const isDark = style.selectedChartBackgroundColor.isDark();
                let selectedChartBackgroundColorRGB = {r: 0, g: 0, b: 0};
                if (isDark) {
                    selectedChartBackgroundColorRGB = color.HEX2RGB(style.selectedChartBackgroundColor.lighten(3));
                } else {
                    selectedChartBackgroundColorRGB = color.HEX2RGB(style.selectedChartBackgroundColor.darken(5));
                }
    
                model.selectedChartBackgroundColor = new ChartStyleColorModel(selectedChartBackgroundColorRGB);
    
                model.isDarkTheme = model.selectedChartBackgroundColor.isDark();
    
                let selectedChartGradientColorRGB = {r: 0, g: 0, b: 0};
                if (isDark) {
                    selectedChartGradientColorRGB = color.HEX2RGB(style.selectedChartGradientColor.lighten(5));
                } else {
                    selectedChartGradientColorRGB = color.HEX2RGB(style.selectedChartGradientColor.darken(8));
                }
    
                model.selectedChartGradientColor = new ChartStyleColorModel(selectedChartGradientColorRGB);
            }

            this.chartStyle = model;
            for (const callback of this.subscribeChartStyleDataCallbacks) {
                callback(model);
            }
        });
    }

    public subscribePnlData(callback: Function) {
    }

    public subscribeCompanyLogoData(callback: Function) {
    }

    public subscribeCurrentPositionData(callback: Function) {
    }

    public subscribeTICompanyLogoData(callback: Function) {
    }

    public subscribeChartRequirementsData(callback: Function) {
    }

    public subscribeChartAllowBuyData(callback: Function) {
    }

    public subscribeChartAllowSellData(callback: Function) {
        // this.subscribeChartAllowSellDataCallbacks.push(callback);
    }

    public subscribeDrawTradeOrdersData(callback: Function) {
        // this.subscribeDrawTradeOrdersDataCallbacks.push(callback);
    }

    public subscribeDrawOrderExecutionData(callback: Function) {
        // this.subscribeDrawOrderExecutionDataCallbacks.push(callback);
    }

    private subscribedPriceAlert = false;
    public subscribePriceAlertsData(callback: Function) {
        this.subscribePriceAlertsDataCallbacks.push(callback);

        if (this.subscribedPriceAlert) {
            return;
        }

        this.subscribedPriceAlert = true;
        this.baseChart.baseChart.chartService.subscribePriceAlertsData((limitAlerts: Array<LimitAlertModel>) => {
            if (this.chartStyle && this.chartStyle.pnpPriceAlertEnabled && this.subscribePriceAlertsDataCallbacks.length) {
                for (const callback of this.subscribePriceAlertsDataCallbacks) {
                    callback(limitAlerts);
                }
            }
        });
    }

    public subscribePriceAlertsImageData(callback: Function) {
    }

    public subscribeEarningNotificationData(callback: Function) {
    }

    public subscribeHaltedNotificationData(callback: Function) {
    }

    public subscribeLastPriceData(callback: Function) {
        this.baseChart.baseChart.chartService.subscribeLastPriceData(callback);
        // this.subscribeLastPriceDataCallbacks.push(callback);
    }

    public subscribeDrawTradePriceAnnotations(callback: Function) {
    }

    public subscribeWindowMinimizeUpdate(callback: Function) {
        // this.subscribeWindowMinimizeUpdateCallbacks.push(callback);
    }

    public subscribeSwingExitData(callback: Function) {
        // this.subscribeSwingExitDataCallbacks.push(callback);
    }

    public subscribeSmartRiskData(callback: Function) {
        // this.subscribSmartRiskDataCallbacks.push(callback);
    }

    public subscribeHeartStatusData(callback: Function) {
        // this.subscribHeartStatusDataCallbacks.push(callback);
    }

    private subscribedDrawEarningNotification = false;
    public subscribeDrawEarningNotificationData(callback: Function) {
        this.subscribeDrawEarningNotificationDataCallbacks.push(callback);

        if (this.subscribedDrawEarningNotification) {
            return;
        }

        this.subscribedDrawEarningNotification = true;
        this.baseChart.baseChart.chartService.subscribeDrawEarningNotificationData((item: DrawEarningNotificationDataModel) => {
            const model = new DrawEarningNotificationDataModel(ObjectHelpers.copy(item));
            model.earningDate = new Date(model.earningDate);

            if (this.baseChart.tiChartSeries?.tiChartPoints?.length) {
                for (const chartData of this.baseChart.tiChartSeries.tiChartPoints) {
                    const pointStartDateStr = DateHelpers.format('dd-mm-yyyy', chartData.start);
                    const pastEarningsDateStr = DateHelpers.format('dd-mm-yyyy', model.earningDate);

                    if (pointStartDateStr == pastEarningsDateStr) {
                        model.xValue = chartData.xValue;
                        break;
                    }
                }
            }
            
            for (const callback of this.subscribeDrawEarningNotificationDataCallbacks) {
                callback(model);
            }
        });
    }

    public subscribeEmojiData(callback: Function) {
    }

    public notifyChartHideContextMenu() {
    }

    public requestHistory() {
        if (!this.winformObjHasValue()) {
            return;
        }

        winformObj.requestPnPHistory();
    }

    public requestOpenSymbolLookup(symbol: string) {
    }

    public requestNewSymbol(symbol: string) {
    }

    public requestNewTimeframe(timeframe: Timeframe) {
        if (!this.winformObjHasValue()) {
            return;
        }

        winformObj.switchPnPTimeframe(timeframe);
    }

    public requestNewChartType(chartType: ChartType) {
    }

    public requestBuy() {
    }

    public requestSell() {
    }

    public requestInitiateChartTrade(price: number, isLong: boolean) {
    }

    public requestUpdateChartTrade(orderId: string, price: number) {
    }

    public requestUpdateLimitAlert(id: string, price: number) {
        if (!this.winformObjHasValue()) {
            return;
        }

        winformObj.requestUpdateLimitAlert(id, price);
    }

    public requestRemoveChartTrade(orderId: string) {
    }

    public requestRemoveLimitAlert(id: string) {
        if (!this.winformObjHasValue()) {
            return;
        }

        winformObj.requestRemoveLimitAlert(id);
    }

    public requestUpdateLastPriceClicked(price: number) {
        if (!this.winformObjHasValue()) {
            return;
        }

        winformObj.requestUpdateLastPriceClicked(price, true);
    }

    public requestAddIndicators() {
    }

    public requestAddPriceAlert() {
    }

    public requestAddAVWap(xValue: number) {
    }

    public requestAddComparisonSymbols() {
    }

    public requestOpenComparisonSymbolLookup(symbol: string) {
    }

    public requestSetHeartLikedStatus() {
    }

    public requestCameraTakeScreenshot() {
    }

    public requestSetZoomLevel(clientZoomLevel: number) {
    }

    public requestSetPnPState(position: string, expanded: boolean, timeframe: Timeframe) {
        if (!this.winformObjHasValue()) {
            return;
        }

        winformObj.requestSetPnPState(position, expanded, timeframe);
    }

    public requestMouseEnter() {
    }

    public requestMouseLeave() {
    }

    public requestSaveDrawingTools(data: Array<any>) {
    }

    public chartReady() {
    }

    private winformObjHasValue() {
        return typeof (winformObj) != 'undefined' && !!winformObj;
    }
}
